import { 
  collection, 
  getDocs, 
  query, 
  where, 
  addDoc, 
  updateDoc, 
  doc,
  limit,
  orderBy, 
  getDoc,
  startAfter,
  increment,
  serverTimestamp
} from 'firebase/firestore';
import { db } from './firebase';

const STATIONS_COLLECTION = 'stations';

// Mock stations data for development
const mockStations = [
  // Europe
  {
    id: '1',
    name: 'NDR 2',
    country: 'Germany',
    city: 'Hamburg',
    genres: ['Pop', 'Rock'],
    streamUrl: 'https://icecast.ndr.de/ndr/ndr2/hamburg/mp3/128/stream.mp3',
    listeners: 7850,
    longitude: 9.9937,
    latitude: 53.5511,
    trending: true,
  },
  {
    id: '2',
    name: 'Radio Paradise',
    country: 'USA',
    city: 'Paradise',
    genres: ['Eclectic', 'Rock', 'World'],
    streamUrl: 'https://stream.radioparadise.com/mp3-128',
    listeners: 8350,
    longitude: -121.6219,
    latitude: 39.7596,
    trending: true,
  },
  {
    id: '3',
    name: 'Soma FM - Groove Salad',
    country: 'USA',
    city: 'San Francisco',
    genres: ['Electronic', 'Ambient'],
    streamUrl: 'https://ice1.somafm.com/groovesalad-128-mp3',
    fallbackUrls: [
      'https://ice2.somafm.com/groovesalad-128-mp3',
      'https://ice4.somafm.com/groovesalad-128-mp3'
    ],
    listeners: 8750,
    longitude: -122.4194,
    latitude: 37.7749,
    trending: true,
  },
  {
    id: '4',
    name: 'Radio Meuh',
    country: 'France',
    city: 'Paris',
    genres: ['Electronic', 'Jazz'],
    streamUrl: 'https://radiomeuh.ice.infomaniak.ch/radiomeuh-128.mp3',
    listeners: 5842,
    longitude: 2.3522,
    latitude: 48.8566,
    trending: true,
  },
  {
    id: '5',
    name: 'Radio Nova',
    country: 'France',
    city: 'Paris',
    genres: ['Alternative', 'World', 'Urban'],
    streamUrl: 'https://novazz.ice.infomaniak.ch/novazz-128.mp3',
    listeners: 4520,
    longitude: 2.3316,
    latitude: 48.8720,
    trending: true,
  },
  
  // Additional European Stations
  {
    id: '21',
    name: 'BBC Radio 6 Music',
    country: 'United Kingdom',
    city: 'London',
    genres: ['Alternative', 'Indie', 'Eclectic'],
    streamUrl: 'https://stream.live.vc.bbcmedia.co.uk/bbc_6music',
    listeners: 7850,
    longitude: -0.1276,
    latitude: 51.5072,
  },
  {
    id: '22',
    name: 'RTL France',
    country: 'France',
    city: 'Paris',
    genres: ['Variety', 'Talk', 'News'],
    streamUrl: 'https://icecast.rtl.fr/rtl-1-44-128?listen=webCwsBCggNCQgLDQUGBAcGBg',
    listeners: 8450,
    longitude: 2.3522,
    latitude: 48.8566,
  },
  {
    id: '23',
    name: 'Europa FM',
    country: 'Spain',
    city: 'Madrid',
    genres: ['Pop', 'Rock', 'Top 40'],
    streamUrl: 'https://livestreaming.esradio.fm/stream64.mp3',
    listeners: 6780,
    longitude: -3.7038,
    latitude: 40.4168,
  },
  {
    id: '24',
    name: 'Radio Italia',
    country: 'Italy',
    city: 'Milan',
    genres: ['Italian Pop', 'Contemporary', 'Variety'],
    streamUrl: 'https://radioitaliasmi-lh.akamaihd.net/i/radioitaliasmi_1@329643/master.m3u8',
    listeners: 7240,
    longitude: 9.1900,
    latitude: 45.4642,
  },
  {
    id: '25',
    name: 'Antenne Bayern',
    country: 'Germany',
    city: 'Munich',
    genres: ['Pop', 'Top 40', 'Variety'],
    streamUrl: 'https://stream.antenne.de/antenne/stream/mp3',
    listeners: 7860,
    longitude: 11.5820,
    latitude: 48.1351,
  },
  {
    id: '26',
    name: 'Radio RAI 1',
    country: 'Italy',
    city: 'Rome',
    genres: ['Talk', 'News', 'Variety'],
    streamUrl: 'https://icestreaming.rai.it/1.mp3',
    listeners: 6240,
    longitude: 12.4964,
    latitude: 41.9028,
  },
  {
    id: '27',
    name: 'Radio ZET',
    country: 'Poland',
    city: 'Warsaw',
    genres: ['Pop', 'Rock', 'News'],
    streamUrl: 'https://zt01.cdn.eurozet.pl/zet-net.mp3',
    listeners: 6580,
    longitude: 21.0122,
    latitude: 52.2297,
  },
  {
    id: '28',
    name: 'Virgin Radio Italy',
    country: 'Italy',
    city: 'Milan',
    genres: ['Rock', 'Alternative', 'Pop Rock'],
    streamUrl: 'https://icecast.unitedradio.it/Virgin.mp3',
    listeners: 5940,
    longitude: 9.1900,
    latitude: 45.4642,
  },
  {
    id: '29',
    name: 'France Inter',
    country: 'France',
    city: 'Paris',
    genres: ['Talk', 'News', 'Culture'],
    streamUrl: 'https://icecast.radiofrance.fr/franceinter-midfi.mp3',
    listeners: 7850,
    longitude: 2.3522,
    latitude: 48.8566,
  },
  {
    id: '30',
    name: 'RTÉ 2FM',
    country: 'Ireland',
    city: 'Dublin',
    genres: ['Contemporary', 'Pop', 'Rock'],
    streamUrl: 'https://www.rte.ie/manifests/2fm.m3u8',
    listeners: 5120,
    longitude: -6.2603,
    latitude: 53.3498,
  },
  
  // Nordic Countries
  {
    id: '31',
    name: 'P3 Sweden',
    country: 'Sweden',
    city: 'Stockholm',
    genres: ['Pop', 'Contemporary', 'Swedish'],
    streamUrl: 'https://http-live.sr.se/p3-mp3-192',
    listeners: 5840,
    longitude: 18.0686,
    latitude: 59.3293,
  },
  {
    id: '32',
    name: 'NRK P3',
    country: 'Norway',
    city: 'Oslo',
    genres: ['Alternative', 'Pop', 'Urban'],
    streamUrl: 'https://lyd.nrk.no/nrk_radio_p3_mp3_h',
    listeners: 4960,
    longitude: 10.7522,
    latitude: 59.9139,
  },
  {
    id: '33',
    name: 'Radio Nova Finland',
    country: 'Finland',
    city: 'Helsinki',
    genres: ['Pop', 'Rock', 'Finnish'],
    streamUrl: 'https://stream.bauermedia.fi/radionova/radionova_64.aac',
    listeners: 5380,
    longitude: 24.9384,
    latitude: 60.1699,
  },
  {
    id: '34',
    name: 'DR P4',
    country: 'Denmark',
    city: 'Copenhagen',
    genres: ['Variety', 'Pop', 'Talk'],
    streamUrl: 'https://drradio2-lh.akamaihd.net/i/p4kobenhavn_9@143509/master.m3u8',
    listeners: 6240,
    longitude: 12.5683,
    latitude: 55.6761,
  },
  {
    id: '35',
    name: 'RÚV Rondó',
    country: 'Iceland',
    city: 'Reykjavik',
    genres: ['Classical', 'Jazz', 'Cultural'],
    streamUrl: 'https://ruv-rondo-live-hls.secure.footprint.net/hls-live/ruv-ras3/_definst_/live.m3u8',
    listeners: 2760,
    longitude: -21.9426,
    latitude: 64.1466,
  },
  
  // African Stations
  {
    id: '8',
    name: 'Bush Radio',
    country: 'South Africa',
    city: 'Cape Town',
    genres: ['Community', 'Talk', 'African'],
    streamUrl: 'https://zas3.ndx.co.za:8002/stream',
    listeners: 2890,
    longitude: 18.4241,
    latitude: -33.9249,
  },
  {
    id: '9',
    name: 'Capital FM Kenya',
    country: 'Kenya',
    city: 'Nairobi',
    genres: ['Pop', 'Urban', 'African'],
    streamUrl: 'https://icecast2.getstreamhosting.com:8050/stream.mp3',
    listeners: 3750,
    longitude: 36.8219,
    latitude: -1.2921,
  },
  {
    id: '10',
    name: 'Radio Africa Online',
    country: 'Ghana',
    city: 'Accra',
    genres: ['Afropop', 'Highlife', 'African'],
    streamUrl: 'https://stream.radioafricaonline.com:8443/afropop',
    listeners: 2450,
    longitude: -0.1870,
    latitude: 5.6037,
  },
  {
    id: '36',
    name: 'Kaya FM',
    country: 'South Africa',
    city: 'Johannesburg',
    genres: ['Jazz', 'Soul', 'African'],
    streamUrl: 'https://live.kayafm.co.za/KayaFM',
    listeners: 4120,
    longitude: 28.0473,
    latitude: -26.2041,
  },
  {
    id: '37',
    name: 'Metro FM',
    country: 'South Africa',
    city: 'Johannesburg',
    genres: ['Urban', 'Kwaito', 'Hip Hop'],
    streamUrl: 'https://playerservices.streamtheworld.com/api/livestream-redirect/METROFM.mp3',
    listeners: 5460,
    longitude: 28.0473,
    latitude: -26.2041,
  },
  {
    id: '38',
    name: 'Radio Jambo',
    country: 'Kenya',
    city: 'Nairobi',
    genres: ['News', 'Talk', 'Sports'],
    streamUrl: 'https://stream.radioafrica.co.ke/radiojambo',
    listeners: 4580,
    longitude: 36.8219,
    latitude: -1.2921,
  },
  {
    id: '39',
    name: 'Radio Cairo',
    country: 'Egypt',
    city: 'Cairo',
    genres: ['Arabic', 'News', 'Cultural'],
    streamUrl: 'https://stream.radiojar.com/g5ztcfpucm8uv',
    listeners: 3870,
    longitude: 31.2357,
    latitude: 30.0444,
  },
  {
    id: '40',
    name: 'Radio 2000',
    country: 'South Africa',
    city: 'Johannesburg',
    genres: ['Pop', 'Sports', 'Talk'],
    streamUrl: 'https://playerservices.streamtheworld.com/api/livestream-redirect/RADIO2000.mp3',
    listeners: 3650,
    longitude: 28.0473,
    latitude: -26.2041,
  },
  
  // Asian Stations
  {
    id: '11',
    name: 'J-Wave',
    country: 'Japan',
    city: 'Tokyo',
    genres: ['J-Pop', 'Jazz', 'Electronic'],
    streamUrl: 'https://tokyofm.stream.laut.fm/tokyo_fm',
    listeners: 4200,
    longitude: 139.6503,
    latitude: 35.6762,
  },
  {
    id: '41',
    name: 'Tokyo FM',
    country: 'Japan',
    city: 'Tokyo',
    genres: ['J-Pop', 'Rock', 'Talk'],
    streamUrl: 'https://tokyofm.stream.laut.fm/tokyo_fm',
    listeners: 6850,
    longitude: 139.6503,
    latitude: 35.6762,
  },
  {
    id: '42',
    name: 'Virgin Radio Dubai',
    country: 'United Arab Emirates',
    city: 'Dubai',
    genres: ['Pop', 'Dance', 'International'],
    streamUrl: 'https://stream.radiojar.com/7qyvpnex9vzuv',
    listeners: 4870,
    longitude: 55.2708,
    latitude: 25.2048,
  },
  {
    id: '43',
    name: 'Radio Thailand',
    country: 'Thailand',
    city: 'Bangkok',
    genres: ['Thai Pop', 'News', 'Traditional'],
    streamUrl: 'https://radiothainews.prd.go.th/stream',
    listeners: 3790,
    longitude: 100.5018,
    latitude: 13.7563,
  },
  {
    id: '44',
    name: 'Hitz FM Malaysia',
    country: 'Malaysia',
    city: 'Kuala Lumpur',
    genres: ['Pop', 'Top 40', 'International'],
    streamUrl: 'https://astro1.rastream.com/hitz',
    listeners: 5620,
    longitude: 101.6869,
    latitude: 3.1390,
  },
  {
    id: '45',
    name: 'Prambors FM',
    country: 'Indonesia',
    city: 'Jakarta',
    genres: ['Pop', 'Indonesian', 'Top 40'],
    streamUrl: 'https://playerservices.streamtheworld.com/api/livestream-redirect/PRAMBORS_FM.mp3',
    listeners: 6230,
    longitude: 106.8456,
    latitude: -6.2088,
  },
  {
    id: '46',
    name: 'KBS Cool FM',
    country: 'South Korea',
    city: 'Seoul',
    genres: ['K-Pop', 'Korean Rock', 'Top 40'],
    streamUrl: 'https://cfbstreaming.kbs.co.kr/cbs_cool_buf01/myStream.stream/playlist.m3u8',
    listeners: 5840,
    longitude: 126.9918,
    latitude: 37.5519,
  },
  {
    id: '47',
    name: 'Love Radio Manila',
    country: 'Philippines',
    city: 'Manila',
    genres: ['Pop', 'OPM', 'Love Songs'],
    streamUrl: 'https://lovehits.stream.laut.fm/lovehits',
    listeners: 4760,
    longitude: 120.9842,
    latitude: 14.5995,
  },
  {
    id: '48',
    name: 'Radio Heart Nepal',
    country: 'Nepal',
    city: 'Kathmandu',
    genres: ['Nepali', 'Folk', 'Pop'],
    streamUrl: 'https://streaming.hamropatro.com/radio-heart-nepal',
    listeners: 2940,
    longitude: 85.3240,
    latitude: 27.7172,
  },
  {
    id: '49',
    name: 'VIVA FM Mongolia',
    country: 'Mongolia',
    city: 'Ulaanbaatar',
    genres: ['Pop', 'Mongolian', 'International'],
    streamUrl: 'https://stream.zeno.fm/ye65ve9twchvv',
    listeners: 2540,
    longitude: 106.9057,
    latitude: 47.8864,
  },
  {
    id: '50',
    name: 'Asia Plus',
    country: 'Tajikistan',
    city: 'Dushanbe',
    genres: ['Pop', 'Central Asian', 'News'],
    streamUrl: 'https://radio.asiaplusgroup.tj:8000/radio1',
    listeners: 2180,
    longitude: 68.7870,
    latitude: 38.5598,
  },
  
  // Indian Stations
  {
    id: '14',
    name: 'Radio Mirchi',
    country: 'India',
    city: 'Mumbai',
    genres: ['Bollywood', 'Hindi', 'Indian Pop'],
    streamUrl: 'https://radioindia.net/radio/mirchi98/icecast.audio',
    listeners: 6750,
    longitude: 72.8777,
    latitude: 19.0760,
  },
  
  // North American Stations
  {
    id: '51',
    name: 'KCRW',
    country: 'United States',
    city: 'Los Angeles',
    genres: ['Eclectic', 'Alternative', 'News'],
    streamUrl: 'https://kcrw.streamguys1.com/kcrw_192k_mp3_on_air',
    listeners: 7240,
    longitude: -118.2437,
    latitude: 34.0522,
  },
  {
    id: '52',
    name: 'WFMU',
    country: 'United States',
    city: 'Jersey City',
    genres: ['Freeform', 'Eclectic', 'Independent'],
    streamUrl: 'https://wfmu.org/wfmu.pls',
    listeners: 4950,
    longitude: -74.0431,
    latitude: 40.7178,
  },
  {
    id: '53',
    name: 'KEXP Seattle',
    country: 'United States',
    city: 'Seattle',
    genres: ['Alternative', 'Indie', 'Rock'],
    streamUrl: 'https://kexp.streamguys1.com/kexp160.aac',
    listeners: 8120,
    longitude: -122.3321,
    latitude: 47.6062,
  },
  {
    id: '54',
    name: 'WNYC',
    country: 'United States',
    city: 'New York',
    genres: ['News', 'Talk', 'Cultural'],
    streamUrl: 'https://fm939.wnyc.org/wnycfm-web',
    listeners: 7580,
    longitude: -74.0060,
    latitude: 40.7128,
  },
  {
    id: '55',
    name: 'KQED',
    country: 'United States',
    city: 'San Francisco',
    genres: ['News', 'Talk', 'Public Radio'],
    streamUrl: 'https://streams.kqed.org/kqedradio',
    listeners: 6850,
    longitude: -122.4194,
    latitude: 37.7749,
  },
  {
    id: '56',
    name: 'Hot 97',
    country: 'United States',
    city: 'New York',
    genres: ['Hip Hop', 'R&B', 'Urban'],
    streamUrl: 'https://playerservices.streamtheworld.com/api/livestream-redirect/WQHTFM.mp3',
    listeners: 8950,
    longitude: -74.0060,
    latitude: 40.7128,
  },
  {
    id: '57',
    name: 'Power 106',
    country: 'United States',
    city: 'Los Angeles',
    genres: ['Hip Hop', 'Urban', 'Top 40'],
    streamUrl: 'https://playerservices.streamtheworld.com/api/livestream-redirect/KPWR_FM.mp3',
    listeners: 7640,
    longitude: -118.2437,
    latitude: 34.0522,
  },
  {
    id: '58',
    name: 'KISS FM Dallas',
    country: 'United States',
    city: 'Dallas',
    genres: ['Top 40', 'Pop', 'Contemporary'],
    streamUrl: 'https://stream.revma.ihrhls.com/zc2305',
    listeners: 6240,
    longitude: -96.7970,
    latitude: 32.7767,
  },
  {
    id: '59',
    name: 'WXPN',
    country: 'United States',
    city: 'Philadelphia',
    genres: ['Adult Album Alternative', 'Indie', 'Rock'],
    streamUrl: 'https://wxpnhi.xpn.org/xpnhi',
    listeners: 5780,
    longitude: -75.1652,
    latitude: 39.9526,
  },
  {
    id: '60',
    name: 'La Que Buena',
    country: 'United States',
    city: 'Los Angeles',
    genres: ['Regional Mexican', 'Latin', 'Spanish'],
    streamUrl: 'https://playerservices.streamtheworld.com/api/livestream-redirect/KBUE_FMAAC.aac',
    listeners: 6120,
    longitude: -118.2437,
    latitude: 34.0522,
  },
  
  // Canadian Stations
  {
    id: '61',
    name: 'CBC Radio One',
    country: 'Canada',
    city: 'Toronto',
    genres: ['News', 'Talk', 'Public Radio'],
    streamUrl: 'https://cbcradiolive.akamaized.net/hls/live/2041050/ES_R1TOR/master.m3u8',
    listeners: 6780,
    longitude: -79.3832,
    latitude: 43.6532,
  },
  {
    id: '62',
    name: 'CHUM FM',
    country: 'Canada',
    city: 'Toronto',
    genres: ['Hot AC', 'Pop', 'Top 40'],
    streamUrl: 'https://playerservices.streamtheworld.com/api/livestream-redirect/CHUMFM.mp3',
    listeners: 7240,
    longitude: -79.3832,
    latitude: 43.6532,
  },
  {
    id: '63',
    name: 'ICI Musique',
    country: 'Canada',
    city: 'Montreal',
    genres: ['Variety', 'Francophone', 'Cultural'],
    streamUrl: 'https://cbcradiolive.akamaized.net/hls/live/2041057/ES_M2MTL/master.m3u8',
    listeners: 5240,
    longitude: -73.5673,
    latitude: 45.5017,
  },
  {
    id: '64',
    name: 'The Peak Vancouver',
    country: 'Canada',
    city: 'Vancouver',
    genres: ['Alternative', 'Indie', 'Canadian'],
    streamUrl: 'https://playerservices.streamtheworld.com/api/livestream-redirect/CKNWFM.mp3',
    listeners: 4820,
    longitude: -123.1207,
    latitude: 49.2827,
  },
  {
    id: '65',
    name: 'CJAY 92',
    country: 'Canada',
    city: 'Calgary',
    genres: ['Rock', 'Classic Rock', 'Hard Rock'],
    streamUrl: 'https://playerservices.streamtheworld.com/api/livestream-redirect/CJAYFM.mp3',
    listeners: 5160,
    longitude: -114.0719,
    latitude: 51.0447,
  },
  
  // South American Stations
  {
    id: '17',
    name: 'La 100',
    country: 'Argentina',
    city: 'Buenos Aires',
    genres: ['Pop', 'Latin', 'Contemporary'],
    streamUrl: 'https://playerservices.streamtheworld.com/api/livestream-redirect/FM999_56.mp3',
    listeners: 4980,
    longitude: -58.3816,
    latitude: -34.6037,
  },
  {
    id: '18',
    name: 'Rádio Disney Brasil',
    country: 'Brazil',
    city: 'São Paulo',
    genres: ['Pop', 'Brazilian', 'International'],
    streamUrl: 'https://playerservices.streamtheworld.com/api/livestream-redirect/DISNEY_BRA_SP.mp3',
    listeners: 5420,
    longitude: -46.6333,
    latitude: -23.5505,
  },
  {
    id: '19',
    name: 'Radio Caracol',
    country: 'Colombia',
    city: 'Bogotá',
    genres: ['News', 'Latin', 'Talk'],
    streamUrl: 'https://playerservices.streamtheworld.com/api/livestream-redirect/CARACOL_RADIO.mp3',
    listeners: 4350,
    longitude: -74.0721,
    latitude: 4.7110,
  },
  {
    id: '20',
    name: 'Radio Corazón',
    country: 'Chile',
    city: 'Santiago',
    genres: ['Latin Pop', 'Romantic', 'Ballads'],
    streamUrl: 'https://playerservices.streamtheworld.com/api/livestream-redirect/CORAZON.mp3',
    listeners: 3780,
    longitude: -70.6693,
    latitude: -33.4489,
  }
];

// Helper function to determine if we should use mock data
// const useMockData = process.env.NODE_ENV === 'development';
const useMockData = false; // Always use real data from Firestore

// Cache for stations to minimize Firestore reads
let stationsCache = null;
let lastVisible = null;
const PAGE_SIZE = 20;

/**
 * Fetch all radio stations from Firestore
 */
export const fetchAllStations = async () => {
  try {
    // Return cached data if available
    if (stationsCache) {
      return stationsCache;
    }

    const stationsRef = collection(db, STATIONS_COLLECTION);
    const stationsSnap = await getDocs(stationsRef);
    
    const stations = stationsSnap.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    
    // Cache the results
    stationsCache = stations;
    
    return stations;
  } catch (error) {
    console.error('Error fetching all stations:', error);
    throw error;
  }
};

/**
 * Fetch stations with pagination
 */
export const fetchStations = async (reset = false) => {
  try {
    if (reset) {
      lastVisible = null;
    }

    let stationsQuery;
    
    if (lastVisible) {
      stationsQuery = query(
        collection(db, STATIONS_COLLECTION),
        orderBy("name"),
        startAfter(lastVisible),
        limit(PAGE_SIZE)
      );
    } else {
      stationsQuery = query(
        collection(db, STATIONS_COLLECTION),
        orderBy("name"),
        limit(PAGE_SIZE)
      );
    }
    
    const stationsSnap = await getDocs(stationsQuery);
    
    // Get the last visible document for pagination
    lastVisible = stationsSnap.docs[stationsSnap.docs.length - 1];
    
    const stations = stationsSnap.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    
    return {
      stations,
      hasMore: stationsSnap.docs.length === PAGE_SIZE
    };
  } catch (error) {
    console.error('Error fetching stations with pagination:', error);
    throw error;
  }
};

/**
 * Fetch a single station by ID
 */
export const fetchStationById = async (stationId) => {
  try {
    // Check cache first
    if (stationsCache) {
      const cachedStation = stationsCache.find(station => station.id === stationId);
      if (cachedStation) {
        return cachedStation;
      }
    }
    
    const stationRef = doc(db, STATIONS_COLLECTION, stationId);
    const stationSnap = await getDoc(stationRef);
    
    if (stationSnap.exists()) {
      return {
        id: stationSnap.id,
        ...stationSnap.data()
      };
    } else {
      return null;
    }
  } catch (error) {
    console.error(`Error fetching station ${stationId}:`, error);
    throw error;
  }
};

/**
 * Search stations by name, genre, country, or language
 */
export const searchStations = async (searchTerm) => {
  try {
    // If we have a cache, search in memory
    if (stationsCache) {
      const lowercaseSearch = searchTerm.toLowerCase();
      return stationsCache.filter(station => 
        station.name.toLowerCase().includes(lowercaseSearch) ||
        station.country.toLowerCase().includes(lowercaseSearch) ||
        (station.language && station.language.toLowerCase().includes(lowercaseSearch)) ||
        (station.genres && station.genres.some(genre => 
          genre.toLowerCase().includes(lowercaseSearch)
        ))
      );
    }
    
    // Otherwise, we need to fetch all and then filter
    // Note: Firestore doesn't support full text search natively
    // For a production app, consider using Algolia or similar
    const stations = await fetchAllStations();
    
    const lowercaseSearch = searchTerm.toLowerCase();
    return stations.filter(station => 
      station.name.toLowerCase().includes(lowercaseSearch) ||
      station.country.toLowerCase().includes(lowercaseSearch) ||
      (station.language && station.language.toLowerCase().includes(lowercaseSearch)) ||
      (station.genres && station.genres.some(genre => 
        genre.toLowerCase().includes(lowercaseSearch)
      ))
    );
  } catch (error) {
    return [];
  }
};

/**
 * Fetch stations by genre
 */
export const fetchStationsByGenre = async (genre) => {
  try {
    // If we have a cache, filter in memory
    if (stationsCache) {
      return stationsCache.filter(station => 
        station.genres && station.genres.includes(genre)
      );
    }
    
    // Otherwise query Firestore
    const stationsRef = collection(db, "stations");
    const genreQuery = query(stationsRef, where("genres", "array-contains", genre));
    const stationsSnap = await getDocs(genreQuery);
    
    return stationsSnap.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    console.error(`Error fetching stations by genre ${genre}:`, error);
    throw error;
  }
};

/**
 * Fetch stations by country
 */
export const fetchStationsByCountry = async (country) => {
  if (!country) {
    throw new Error('Country parameter is required');
  }
  
  if (useMockData) {
    // Mock implementation for development - filter stations by country
    const countryStations = mockStations.filter(station => {
      // Case-insensitive matching for country names
      const stationCountry = station.country?.toLowerCase();
      const searchCountry = country.toLowerCase();
      
      return stationCountry === searchCountry;
    });
    
    // Sort by listeners count for more interesting results
    const sortedStations = countryStations.sort((a, b) => b.listeners - a.listeners);
    
    return new Promise(resolve => {
      setTimeout(() => resolve(sortedStations), 800);
    });
  }

  try {
    // Get stations from Firestore that match the country
    const stationsRef = collection(db, "stations");
    const q = query(stationsRef, where('country', '==', country));
    const querySnapshot = await getDocs(q);
    
    const stations = [];
    querySnapshot.forEach((doc) => {
      stations.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    // Sort by listeners count
    return stations.sort((a, b) => b.listeners - a.listeners);
  } catch (error) {
    console.error('Error fetching stations by country:', error);
    throw error;
  }
};

/**
 * Update the current song for a station
 */
export const updateCurrentSong = async (stationId, songTitle) => {
  try {
    const stationRef = doc(db, "stations", stationId);
    await updateDoc(stationRef, {
      currentSong: songTitle,
      lastUpdated: serverTimestamp()
    });
    
    // Update cache if it exists
    if (stationsCache) {
      const stationIndex = stationsCache.findIndex(s => s.id === stationId);
      if (stationIndex >= 0) {
        stationsCache[stationIndex].currentSong = songTitle;
      }
    }
    
    return true;
  } catch (error) {
    console.error(`Error updating current song for station ${stationId}:`, error);
    throw error;
  }
};

/**
 * Increment the listener count for a station
 */
export const incrementListeners = async (stationId) => {
  try {
    const stationRef = doc(db, STATIONS_COLLECTION, stationId);
    await updateDoc(stationRef, {
      listeners: increment(1)
    });
    
    // Update cache if it exists
    if (stationsCache) {
      const stationIndex = stationsCache.findIndex(s => s.id === stationId);
      if (stationIndex >= 0 && stationsCache[stationIndex].listeners) {
        stationsCache[stationIndex].listeners += 1;
      }
    }
    
    return true;
  } catch (error) {
    console.error(`Error incrementing listeners for station ${stationId}:`, error);
    throw error;
  }
};

/**
 * Decrement the listener count for a station
 */
export const decrementListeners = async (stationId) => {
  try {
    const stationRef = doc(db, STATIONS_COLLECTION, stationId);
    await updateDoc(stationRef, {
      listeners: increment(-1)
    });
    
    // Update cache if it exists
    if (stationsCache) {
      const stationIndex = stationsCache.findIndex(s => s.id === stationId);
      if (stationIndex >= 0 && stationsCache[stationIndex].listeners) {
        stationsCache[stationIndex].listeners = Math.max(0, stationsCache[stationIndex].listeners - 1);
      }
    }
    
    return true;
  } catch (error) {
    console.error(`Error decrementing listeners for station ${stationId}:`, error);
    throw error;
  }
};

/**
 * Clear the stations cache to fetch fresh data
 */
export const clearStationsCache = () => {
  stationsCache = null;
  lastVisible = null;
};

export const getTrendingStations = async (stationLimit = 10) => {
  if (useMockData) {
    // Filter mock data by trending flag and limit
    const trendingStations = mockStations
      .filter(station => station.trending)
      .slice(0, stationLimit);
    
    return new Promise(resolve => {
      setTimeout(() => resolve(trendingStations), 500);
    });
  }

  try {
    const stationsCollection = collection(db, STATIONS_COLLECTION);
    const trendingQuery = query(
      stationsCollection,
      orderBy('listeners', 'desc'),
      limit(stationLimit)
    );
    
    const stationsSnapshot = await getDocs(trendingQuery);
    return stationsSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
  } catch (error) {
    throw error;
  }
};

export const getStationsByLocation = async (longitude, latitude, radiusInKm = 100) => {
  // Detect if user is in the UK by checking if location is within UK boundaries
  // UK bounds (approximate): lat 49.9-58.7, lon -8.2-1.8
  const isInUK = latitude >= 49.9 && latitude <= 58.7 && longitude >= -8.2 && longitude <= 1.8;
  
  if (useMockData) {
    // Mock implementation for development
    let stationsWithDistance = mockStations.map(station => {
      // Skip stations without coordinates
      if (!station.longitude || !station.latitude) return null;
      
      // Calculate distance
      const distance = getDistanceFromLatLonInKm(
        latitude, 
        longitude, 
        station.latitude, 
        station.longitude
      );
      
      return {
        ...station,
        distance: parseFloat(distance.toFixed(1))  // Round to 1 decimal place
      };
    }).filter(station => station && station.distance <= radiusInKm);
    
    // If user is in the UK, prioritize UK stations
    if (isInUK) {
      // Filter for UK stations first, then sort by distance
      const ukStations = stationsWithDistance.filter(station => 
        station.country === 'United Kingdom' || 
        station.country === 'UK' || 
        station.country === 'England' ||
        station.country === 'Scotland' ||
        station.country === 'Wales' ||
        station.country === 'Northern Ireland'
      );
      
      // If we found UK stations, prioritize them
      if (ukStations.length > 0) {
        const otherStations = stationsWithDistance.filter(station => 
          station.country !== 'United Kingdom' && 
          station.country !== 'UK' &&
          station.country !== 'England' &&
          station.country !== 'Scotland' &&
          station.country !== 'Wales' &&
          station.country !== 'Northern Ireland'
        );
        
        // Sort UK stations by distance, then append other stations
        stationsWithDistance = [
          ...ukStations.sort((a, b) => a.distance - b.distance),
          ...otherStations.sort((a, b) => a.distance - b.distance)
        ];
      } else {
        // Just sort by distance if no UK stations found
        stationsWithDistance = stationsWithDistance.sort((a, b) => a.distance - b.distance);
      }
    } else {
      // Not in UK, just sort by distance
      stationsWithDistance = stationsWithDistance.sort((a, b) => a.distance - b.distance);
    }
    
    return new Promise(resolve => {
      setTimeout(() => resolve(stationsWithDistance), 800);
    });
  }

  try {
    // This is a simplified approach. In a production app, you would use geospatial queries
    // with Firebase or a dedicated geospatial database or service
    const stations = await fetchAllStations();
    
    let localStations = stations.filter(station => {
      if (!station.longitude || !station.latitude) return false;
      
      // Calculate distance using the Haversine formula
      const distance = getDistanceFromLatLonInKm(
        latitude, 
        longitude, 
        station.latitude, 
        station.longitude
      );
      
      // Add distance to station object
      station.distance = parseFloat(distance.toFixed(1));
      
      return distance <= radiusInKm;
    });
    
    // If user is in the UK, prioritize UK stations
    if (isInUK) {
      // Filter for UK stations first, then sort by distance
      const ukStations = localStations.filter(station => 
        station.country === 'United Kingdom' || 
        station.country === 'UK' || 
        station.country === 'England' ||
        station.country === 'Scotland' ||
        station.country === 'Wales' ||
        station.country === 'Northern Ireland'
      );
      
      // If we found UK stations, prioritize them
      if (ukStations.length > 0) {
        const otherStations = localStations.filter(station => 
          station.country !== 'United Kingdom' && 
          station.country !== 'UK' &&
          station.country !== 'England' &&
          station.country !== 'Scotland' &&
          station.country !== 'Wales' &&
          station.country !== 'Northern Ireland'
        );
        
        // Sort UK stations by distance, then append other stations
        localStations = [
          ...ukStations.sort((a, b) => a.distance - b.distance),
          ...otherStations.sort((a, b) => a.distance - b.distance)
        ];
      } else {
        // Just sort by distance if no UK stations found
        localStations = localStations.sort((a, b) => a.distance - b.distance);
      }
    } else {
      // Not in UK, just sort by distance
      localStations = localStations.sort((a, b) => a.distance - b.distance);
    }
    
    return localStations;
  } catch (error) {
    throw error;
  }
};

// Haversine formula to calculate distance between two points on Earth
function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  const R = 6371; // Radius of the Earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  const distance = R * c; // Distance in km
  return distance;
}

/**
 * Calculate distance between coordinates using Haversine formula
 */
export const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  const d = R * c; // Distance in km
  return d;
};

/**
 * Helper function for Haversine formula
 */
function deg2rad(deg) {
  return deg * (Math.PI/180);
}

// Get user's country from coordinates using reverse geocoding
export const getUserCountryFromCoordinates = async (latitude, longitude) => {
  try {
    // First try to use built-in reverse geocoding if available
    if (navigator.geolocation && 'Geolocation' in window) {
      try {
        // Use a free reverse geocoding API
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=18&addressdetails=1`,
          {
            headers: {
              'Accept-Language': navigator.language || 'en-US',
              'User-Agent': 'GlobeTune Radio App'
            }
          }
        );
        
        if (response.ok) {
          const data = await response.json();
          if (data.address && data.address.country) {
            return data.address.country;
          }
        }
      } catch (error) {
        console.warn('Error with reverse geocoding API:', error);
        // Continue to fallback
      }
    }
    
    // Fallback: Determine country based on coordinates using approximate boundaries
    // This is a simplified fallback that checks for some common countries
    
    // UK
    if (latitude >= 49.9 && latitude <= 58.7 && longitude >= -8.2 && longitude <= 1.8) {
      return 'United Kingdom';
    }
    
    // USA (contiguous)
    if (latitude >= 24.4 && latitude <= 49.4 && longitude >= -125.0 && longitude <= -66.9) {
      return 'USA';
    }
    
    // Canada
    if (latitude >= 41.7 && latitude <= 83.0 && longitude >= -141.0 && longitude <= -52.6) {
      return 'Canada';
    }
    
    // Australia
    if (latitude >= -43.6 && latitude <= -10.7 && longitude >= 113.2 && longitude <= 153.6) {
      return 'Australia';
    }
    
    // Germany
    if (latitude >= 47.3 && latitude <= 55.1 && longitude >= 5.9 && longitude <= 15.0) {
      return 'Germany';
    }
    
    // France
    if (latitude >= 41.3 && latitude <= 51.1 && longitude >= -5.1 && longitude <= 9.5) {
      return 'France';
    }
    
    // If we can't determine the country, return null
    return null;
  } catch (error) {
    console.error('Error determining user country:', error);
    return null;
  }
}; 